import axios from 'axios';
import { logoutUser, redirectToLogin } from '../redux/actions';

let _interceptorId = null;

const isImpersonatedClientRequest = (url) => {
  if (!url.includes('/proxy-client/')) return false;
  try {
    return Boolean(sessionStorage.getItem('skusavvy_impersonation'));
  } catch (e) {
    return false;
  }
};

export const setupInterceptors = (dispatch) => {
  if (_interceptorId !== null) {
    axios.interceptors.response.eject(_interceptorId);
  }
  _interceptorId = axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const url = error.config?.url || '';
      const isAuthCheck = url.includes('/auth/isAuth');
      const isBillingNotificationRequest =
        url.includes('/auth/me') ||
        url.includes('/admin/invoice-notifications') ||
        (error.config?.billingNotificationRequest === true &&
          /\/admin\/invoices(?:\?|$)/.test(url));
      const isImpersonation = url.includes('/auth/impersonate') || isImpersonatedClientRequest(url);
      if (
        error.response?.status === 401 &&
        !isAuthCheck &&
        !isBillingNotificationRequest &&
        !isImpersonation
      ) {
        dispatch(logoutUser());
        redirectToLogin();
      }
      return Promise.reject(error);
    },
  );
};
